import {
    Box,
    createStyles,
    List,
    ListItem,
    makeStyles,
    Paper,
    Grid,
    Theme,
    Typography,
    useTheme,
} from '@material-ui/core';
import axios from 'axios';
import clsx from 'clsx';
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
    member as v_member,
    basic,
    Values,
    member,
    order as v_order,
    order,
} from '../request/values';
import { TitleBackBar } from './header/TitleBar';
import { COLORS } from './Theme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { maxWidth } from '@material-ui/system';

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        paddingTop: '0',
        paddingLeft: '0',
        paddingRight: '0',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '40px',
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingBottom: theme.spacing(4),
        },
    },
    productItem: {
        borderRadius: 12,
        margin: 'auto',
        marginBottom: '1.5vh',

        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        width: '82vw',
        paddingTop: '2.2vh',
        paddingBottom: '2.2vh',
        [theme.breakpoints.up('md')]: {
            paddingTop: 'initial',
            paddingBottom: 'initial',
        },
    },
    list: {
        width: '86vw',
        height: '79vh',
        overflowY: 'auto',
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        fontSize: '4vw',
        color: `${COLORS.BROWNISH_GREY}`,
        [theme.breakpoints.up('md')]: {
            height: '100%',
            fontSize: 'initial',
        },
    },
    grid: {
        width: '95%',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(6),
    },
    paper: {
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        padding: theme.spacing(1),
        textAlign: 'center',
    },
    materialImage: {
        textAlign: 'center',
        margin: 'auto',
        '& img': {
            width: '11vw',
            maxWidth: '62px',
        },
    },
    materialDesc: {
        paddingLeft: '1vw',
        '& #materialName': {
            ...theme.typography.subtitle2,
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        },
        '& #materialSubName': {
            ...theme.typography.body2,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            color: `${COLORS.BROWNISH_GREY}`,
        },
    },
    orderComplete: {
        color: `${COLORS.WATER_BLUE}`,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },
    orderNone: {
        color: `${COLORS.DOWN}`,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },

    orderList: {
        width: '100%',
        maxWidth: 360,
    },
    orderSheet: {
        // height : 'calc(100%- 64px)',
        // top: 64
        height: '100vh',
    },
    priceFont: {
        color: `${COLORS.WATER_BLUE}`,
        fontWeight: 'bold',
        [theme.breakpoints.up('md')]: {
            ...theme.typography.body1,
        },
    },
    unitFont: {
        color: `${COLORS.BROWNISH_GREY}`,
        fontWeight: 'bold',
        [theme.breakpoints.up('md')]: {
            ...theme.typography.body1,
        },
    },
}));

interface RouteParams {
    licenseNum: string;
}

const LicenseManual: React.FC<any> = (props) => {
    const classes = useStyles();
    const history = useHistory();
    //const { params } = props.match;
    const { licenseNum } = useParams<RouteParams>();
    const { member } = props;
    const [material, setMaterial] = useState([]);
    const [loading, setLoading] = useState(false);

    const theme = useTheme();
    const isLargeUp = useMediaQuery(theme.breakpoints.up('lg'));

    const getLicenseManual = () => {
        console.log('member? ', member);
        let url = new URL(SERVER + v_member.member + v_member.license_manual);
        let param = {
            licenseNum: licenseNum,
            classVersion: member.classVersion,
        };
        url.search = new URLSearchParams(param).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    setMaterial((prevState) => data.materials);
                    setLoading(true);
                }
            });
    };

    useEffect(() => {
        getLicenseManual();
    }, []);

    return (
        <div className="contentList">
            <div className={classes.wrapper}>
                <TitleBackBar
                    history={history}
                    title="재료목록"
                    titleIcon="help"
                />

                {isLargeUp ? (
                    <Grid container className={classes.grid} spacing={3}>
                        {material != null &&
                            material.map((item: any, index: number) => (
                                <Grid item xs={12} md={6} key={index}>
                                    <Paper className={classes.paper}>
                                        <MaterialOrderItem {...item} />
                                    </Paper>
                                </Grid>
                            ))}
                    </Grid>
                ) : (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <List className={classes.list}>
                            {material != null &&
                                material.map((item: any, index: number) => {
                                    return (
                                        <ListItem
                                            className={classes.productItem}
                                            alignItems="center"
                                        >
                                            {<MaterialOrderItem {...item} />}
                                        </ListItem>
                                    );
                                })}
                        </List>
                    </Box>
                )}
            </div>
        </div>
    );
};

const MaterialOrderItem: React.FC<any> = (props) => {
    const classes = useStyles();
    // const { materialName, materialSubName, materialCode, materialPrice, materialCount } = props

    return (
        <Grid container justify={'center'} alignContent="center" translate="no">
            <Grid xs={2} className={classes.materialImage}>
                <img
                    src={
                        basic.server +
                        '/displayImage?fileName=' +
                        props.materialImage
                    }
                />
            </Grid>
            <Grid xs={7} style={{ margin: 'auto' }}>
                <Grid
                    container
                    className={classes.materialDesc}
                    direction="column"
                >
                    <Grid id="materialName">{props.materialName}</Grid>
                    <Grid id="materialSubName">
                        {props.materialSubName} {props.materialCode}
                    </Grid>
                </Grid>
            </Grid>
            <Grid xs={2} style={{ margin: 'auto' }}>
                <div style={{ textAlign: 'end', margin: 'auto' }}>
                    <Typography
                        display="inline"
                        variant="h3"
                        className={classes.priceFont}
                    >
                        {`${props.materialPrice} `}
                    </Typography>
                    <Typography
                        display="inline"
                        variant="h1"
                        className={classes.unitFont}
                    >
                        원
                    </Typography>
                </div>
                <div style={{ textAlign: 'end' }}>
                    <Typography
                        display="inline"
                        variant="h3"
                        className={classes.priceFont}
                    >
                        {`${props.materialCount} `}
                    </Typography>
                    <Typography
                        display="inline"
                        variant="h1"
                        className={classes.unitFont}
                    >
                        개
                    </Typography>
                </div>
            </Grid>
        </Grid>
    );
};

export default LicenseManual;
